import React from 'react';
import { Box, IconButton, Popper } from '@mui/material';
import { SearchIcon } from 'components/SVG';
import { useComponentSearch, usePopover } from 'hooks/common';
import { SparkComponentSearchField } from 'sharedComponents/UI';

type BoardSearchIconWrapperProps = {
  boardElement?: HTMLElement | null;
};

const BoardSearchIconWrapper = ({
  boardElement,
}: BoardSearchIconWrapperProps) => {
  const { open, anchorEl, openPopover, closePopover } = usePopover();
  const {
    handleSearch,
    previousMatch,
    nextMatch,
    totalMatches,
    currentIndex,
    clearHighlights,
  } = useComponentSearch(boardElement);

  const handleClose = () => {
    closePopover();
    clearHighlights();
  };

  return (
    <>
      <IconButton
        aria-label='AddCircleRoundedIcon'
        onClick={openPopover}
        size='small'
      >
        <SearchIcon width='20' height='20' />
      </IconButton>
      <Popper
        open={open}
        anchorEl={anchorEl}
        disablePortal={true}
        sx={{
          '& .MuiPopper-root': {
            borderRadius: '10px',
          },
          top: '5px !important',
        }}
      >
        <Box
          boxShadow={(theme) => theme.shadows[1]}
          borderRadius='10px'
          overflow='hidden'
        >
          <SparkComponentSearchField
            onChange={handleSearch}
            currentIndex={currentIndex}
            totalMatches={totalMatches}
            onClose={handleClose}
            onNextClick={nextMatch}
            onPreviousClick={previousMatch}
          />
        </Box>
      </Popper>
    </>
  );
};

export default BoardSearchIconWrapper;
